


















































import {Vue, Component, Ref, Prop, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {SelectWings} from "@/components";
import { CollapseTransition } from "vue2-transitions";
import {AddressBookItem} from "@/store/addressbooks/types";
import {notifySuccess, notifyError} from "@/utils/notify-helper";

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportContacts extends Vue {
  @Ref('validator') validator: any;
  @PropSync('show') is_show!: boolean;
  @PropSync('group_id') groupId!: number;
  @PropSync('contact_ids') contactIds: any;
  @Getter("addressBooks") addressBooks: any;
  @Action("getAddressBooks") actionGetItems: any;
  @Action("copyAddressBookContacts") actionCopyAddressBookContacts: any;
  @Action("moveAddressBookContacts") actionMoveAddressBookContacts: any;
  @Action("deleteAddressBookContact") actionDelete: any;

  private action = 'copy'
  private toGroup = null

  get getAddressBook() {
    return this.addressBooks.filter((item: AddressBookItem) => { return item.id != this.groupId })
  }

  created() {
    try {
      this.actionGetItems()
    } catch(error) {
      notifyError(error)
    }
  }

  async onClick() {
    try {
      const formData = {
        fromGroupId: this.groupId,
        toGroupId: this.toGroup,
        contactIds: this.contactIds,
      }

      let res = null
      let message = ''
      if (this.action == 'copy') {
        res = await this.actionCopyAddressBookContacts(formData)
        message = this.$t('contacts.contacts_copied') + ' ' + res.data.contactCount
      }
      if (this.action == 'move') {
        res = await this.actionMoveAddressBookContacts(formData)
        message = this.$t('contacts.contacts_moved') + ' ' + res.data.contactCount
        this.$emit('refresh')
      }
      if (this.action == 'delete') {
        res = await this.actionDelete({contactIds: this.contactIds})
        message = this.$t('contacts.contacts_deleted').toString()
        this.$emit('refresh')
      }
      if (res.data?.mSISDNDuplicates?.length > 0) message += '<br>' + this.$t('contacts.mSISDNDuplicates') + ': ' + res.data.mSISDNDuplicates.join(', ')
      if (res.data?.emailDuplicates?.length > 0) message += '<br>' + this.$t('contacts.emailDuplicates') + ': ' + res.data.emailDuplicates.join(', ')
      notifySuccess(message);

    } catch(error) {
      notifyError(error)
    }
  }

}
